module.exports = __webpack_public_path__ + "img/poya-home.6832923b.svg";